import type { WidgetDefinition } from '@/types';

class Registry {
  private map = new Map<string, WidgetDefinition<any>>();

  register<T>(def: WidgetDefinition<T>): void {
    if (this.map.has(def.type)) {
      console.warn(`[WidgetRegistry] Overriding definition for type "${def.type}"`);
    }
    this.map.set(def.type, def as WidgetDefinition<any>);
  }

  get(type: string): WidgetDefinition<any> | undefined {
    return this.map.get(type);
  }

  list(): WidgetDefinition<any>[] {
    return Array.from(this.map.values());
  }

  byCategory(): Record<string, WidgetDefinition<any>[]> {
    const out: Record<string, WidgetDefinition<any>[]> = {};
    for (const def of this.map.values()) {
      (out[def.category] ??= []).push(def);
    }
    return out;
  }
}

export const widgetRegistry = new Registry();
